// extracted by mini-css-extract-plugin
export default {"buyout__content":"Buyout-module__buyout__content--Xihao","buyout__form":"Buyout-module__buyout__form--h_bbG","buyout__description":"Buyout-module__buyout__description--lLGBA"};